import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IUser } from "@defs/user";

interface UserState {
  data: IUser;
  loading: boolean;
  error: boolean;
  saving: boolean;
  updatingStatus: boolean;
  inviting: boolean;
}

const initialState: UserState = {
  data: null,
  loading: true,
  error: false,
  saving: false,
  updatingStatus: false,
  inviting: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    reset(state) {
      state.loading = true;
      state.data = null;
    },
  },

  extraReducers: {
    "user/detail/pending": (state) => {
      state.loading = initialState.loading;
      state.data = initialState.data;
    },

    "user/detail/fulfilled": (state, action: PayloadAction<IUser>) => {
      state.loading = false;
      state.data = action.payload;
    },

    "user/invite/pending": (state) => {
      state.inviting = true;
    },

    "user/invite/fulfilled": (state) => {
      state.inviting = false;
    },

    "user/create/pending": (state) => {
      state.saving = true;
    },

    "user/create/fulfilled": (state) => {
      state.saving = false;
    },

    "user/create/rejected": (state) => {
      state.saving = false;
    },

    "user/update/pending": (state) => {
      state.saving = true;
    },

    "user/update/fulfilled": (state) => {
      state.saving = false;
    },

    "user/update/rejected": (state) => {
      state.saving = false;
    },

    "user/updateStatus/pending": (state) => {
      state.updatingStatus = true;
    },

    "user/updateStatus/fulfilled": (state, action: PayloadAction<boolean>) => {
      state.updatingStatus = false;
      state.data.active = action.payload;
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice.reducer;
